import styled from 'styled-components';

const SUPPORTED_MIN_WIDTH = 360;

/**
 * tablet breakpoint excluding scrollbar width
 */
export const MAX_CONTAINER_WIDTH = 748;

const ContentContainer = styled.div<{ $noTopSpace?: boolean; }>`
    width: ${ MAX_CONTAINER_WIDTH }px;
    max-width: ${ MAX_CONTAINER_WIDTH }px;
    padding-top: ${ ({ theme, $noTopSpace }) => ($noTopSpace ? '0' : theme.size.size_20) };
    padding-bottom: ${ ({ theme }) => theme.size.size_20 };
    padding-left: ${ ({ theme }) => theme.size.size_30 };
    padding-right: ${ ({ theme }) => theme.size.size_30 };

    margin: 0 auto;
    min-width: ${ SUPPORTED_MIN_WIDTH }px;

    @media ${ ({ theme }) => theme.breakpoints.mediaQueries.isMobile } {
        max-width: 100%;
        width: 100%;
        padding-left: ${ ({ theme }) => theme.size.size_20 };
        padding-right: ${ ({ theme }) => theme.size.size_20 };
    }
`;

export default ContentContainer;
